var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",staticStyle:{"padding-top":"100px"}},[_c('v-card',{attrs:{"flat":"","outlined":""}},[_c('v-card-text',[_vm._l((_vm.logs),function(log){return _c('v-card',{key:log.date,attrs:{"flat":"","outlined":""}},[_c('v-card-text',[_vm._v(_vm._s(log))])],1)}),_c('v-card',[_c('v-card-text')],1)],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }